module.exports = __webpack_public_path__ + "static/media/twitter.6a6de977.svg";